import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from '@/App'
import Home from '@/components/pages/homepage/Home'
import OtherPage from '@/components/pages/OtherPage'
import storeObj from '@/store/store'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Vuex)

/*
  ----------------------
  * Define a VUEX store.
  ----------------------------------------------------------
  Every page has its proper module, and the module name will
  be the same of the route path name,
  (For example: the homepage's module will be named with
  'homePage', as well as the name of its route path)
  --------------------------------------------
  Some modules are referred to some components
  --------------------------------------------
 */
const store = new Vuex.Store(storeObj)

//* Define some routes.
const routes = [
  { path: '/', name: 'homePage', component: Home },
  { path: '/home', name: 'homePage', component: Home },
  { path: '/otherpage', component: OtherPage },
]

//* Create the router instance.
const router = new VueRouter({
  mode: 'history', // remove the #
  routes, // short for `routes: routes`
})

//* Create and mount the root instance.
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
